import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcase16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSuitcase16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 2h2a1 1 0 0 1 1 1v1H6V3a1 1 0 0 1 1-1M5 4V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm6 1H5v3.134a1 1 0 0 1 0 1.732V13h6V9.866a1 1 0 0 1 0-1.732zm1 4.866a1 1 0 0 0 0-1.732V5h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1zM4 5v3.134a1 1 0 0 0 0 1.732V13H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcase16);
